export enum AnalyticsPageName {
  account = 'account',
  accountDeletion = 'accountDeletion',
  accountDeletionConfirmation = 'accountDeletionConfirmation',
  act = 'act',
  cardDetail = 'cardDetail',
  challenges = 'challenges',
  challengeDetail = 'challengeDetail',
  changeEmail = 'changeEmail',
  changeNickname = 'changeNickname',
  compare = 'compare',
  confirmEmail = 'confirmEmail',
  confirmEmailResendCode = 'confirmEmailResendCode',
  confirmNewEmail = 'confirmNewEmail',
  confirmNewEmailResendCode = 'confirmNewEmailResendCode',
  dashboard = 'dashboard',
  dataSource = 'dataSource',
  dialogue = 'dialogue',
  discover = 'discover',
  eligibility = 'eligibility',
  eula = 'eula',
  feedback = 'feedback',
  forgotPassword = 'forgotPassword',
  goOutAndLive = 'goOutAndLive',
  help = 'help',
  home = 'home',
  invite = 'invite',
  landing = 'landing',
  legalDocAcceptance = 'legalDocAcceptance',
  login = 'login',
  loginSelection = 'loginSelection',
  meView = 'meView',
  meEdit = 'meEdit',
  mobileAppInfo = 'mobileAppInfo',
  mobileAppInterstitial = 'mobileAppInterstitial',
  myPhotos = 'myPhotos',
  onboarding = 'onboarding',
  onboardingDialogue = 'onboardingDialogue',
  onboardingLegalDocAcceptance = 'onboardingLegalDocAcceptance',
  postReflection = 'postReflection',
  privacy = 'privacy',
  privacyPledge = 'privacyPledge',
  progress = 'progress',
  pulseSurveyIntroScreen = 'pulseSurveyIntroScreen',
  purposefulDays = 'purposefulDaysExplanation',
  quest = 'quest',
  questionSet = 'questionSet',
  ready = 'ready',
  reflect = 'reflect',
  reminders = 'reminders',
  report = 'report',
  reports = 'reports',
  resetPassword = 'resetPassword',
  resources = 'resources',
  saved = 'saved',
  search = 'search',
  setPassword = 'setPassword',
  settings = 'settings',
  signup = 'signup',
  signupEmail = 'signupEmail',
  singlePhoto = 'singlePhoto',
  takeAction = 'takenAction',
  test = 'test',
  today = 'today',
  welcome = 'welcome',
  workbook = 'workbook',
}
